import "./Results.css";
let contestResults = require('./results.json');

contestResults.sort((x, y) => {
    if (y.results.reduce((a, b) => a + b, 0) - x.results.reduce((a, b) => a + b, 0) == 0) {
        return x.name < y.name ? -1 : 1;
    }
    return y.results.reduce((a, b) => a + b, 0) - x.results.reduce((a, b) => a + b, 0);
});

contestResults[0].rank = 1;
for (let i = 1; i < contestResults.length; i++) {
    let x = contestResults[i - 1].results.reduce((a, b) => a + b, 0) - contestResults[i].results.reduce((a, b) => a + b, 0);
    if (x == 0) contestResults[i].rank = contestResults[i - 1].rank;
    else contestResults[i].rank = contestResults[i - 1].rank + 1;
}

let n = contestResults.length;

for (let i = 0; contestResults[i].rank < 29; i++) {
    contestResults[i].award = "Bronze";
}
for (let i = 0; contestResults[i].rank < 19; i++) {
    contestResults[i].award = "Silver";
}
for (let i = 0; contestResults[i].rank < 8; i++) {
    contestResults[i].award = "Gold";
}


function Results() {

    return (
        <div>
            <h1>Results</h1>
            {/* Official countries :
            <table>
                <tr>
                    <th>Rank</th>
                    <th>Contestant</th>
                    <th>Country</th>
                    <th>P1</th>
                    <th>P2</th>
                    <th>P3</th>
                    <th>P4</th>
                    <th>Score</th>
                    <th>Award</th>
                </tr>
                {contestResults.filter(x => !x.country.includes("*")).map(participant => (
                    <tr class={participant.award}>
                        <td>{participant.rank}</td>
                        <td>{participant.name}</td>
                        <td>{participant.country}</td>
                        <td>{participant.results[0]}</td>
                        <td>{participant.results[1]}</td>
                        <td>{participant.results[2]}</td>
                        <td>{participant.results[3]}</td>
                        <td>{participant.results.reduce((a, b) => a + b, 0).toFixed(2)}</td>
                        <td>{participant.award}</td>
                    </tr>
                ))}
            </table>

            All countries : */}

            <table>
                <tr>
                    <th>Rank</th>
                    <th>Contestant</th>
                    <th>Country</th>
                    <th>P1</th>
                    <th>P2</th>
                    <th>P3</th>
                    <th>P4</th>
                    <th>Score</th>
                    <th>Award</th>
                </tr>
                {contestResults.map(participant => (
                    <tr class={participant.award}>
                        <td>{participant.rank}</td>
                        <td>{participant.name}</td>
                        <td>{participant.country}</td>
                        <td>{participant.results[0]}</td>
                        <td>{participant.results[1]}</td>
                        <td>{participant.results[2]}</td>
                        <td>{participant.results[3]}</td>
                        <td>{participant.results.reduce((a, b) => a + b, 0).toFixed(2)}</td>
                        <td>{participant.award}</td>
                    </tr>
                ))}
            </table>
        </div>
    );
}

export default Results;
